<template>
  <div id="filtrar-concurso">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres
          titulo="Editais"
          :botoes="botoesHeader"
          breakpoint="xl"
        />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form
            @submit.prevent="filtrarConcursos"
            @reset.prevent="limparFiltro"
          >
            <b-row>
              <b-col cols="12" sm="6">
                <default-form-validation-provider label="Banca" rules="">
                  <b-form-select
                    id="select-banca"
                    v-model="filtros.Banca"
                    :options="listaBancasSelect"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6">
                <default-form-validation-provider
                  label="Nº Edital"
                  rules=""
                  v-slot="defaultState"
                >
                  <b-form-input
                    id="input-NrEdital"
                    v-model="filtros.NrEdital"
                    :state="defaultState.state"
                    type="number"
                    min="1"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6">
                <default-form-validation-provider
                  label="Ano"
                  rules=""
                  v-slot="defaultState"
                >
                  <b-form-input
                    id="input-AnoEdital"
                    v-model="filtros.AnoEdital"
                    :state="defaultState.state"
                    type="number"
                    min="1900"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6">
                <default-form-validation-provider label="Tipo" rules="">
                  <b-form-select
                    id="select-Tipo"
                    v-model="filtros.Tipo"
                    :options="listaTiposSelect"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6">
                <default-form-validation-provider label="Situação" rules="">
                  <b-form-select
                    id="select-Situacao"
                    v-model="filtros.Situacao"
                    :options="listaSituacaoSelect"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6">
                <default-form-validation-provider
                  v-if="ehSEAD"
                  label="UG Responsável"
                  rules=""
                >
                  <b-form-select
                    id="select-Responsavel"
                    v-model="filtros.UGResponsavel"
                    :options="listaResponsavelSelect"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="6" xl="3" offset-xl="3">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />
                  Limpar
                </b-button>
              </b-col>
              <b-col cols="6" xl="3">
                <b-button type="submit" :disabled="tableBusy">
                  <font-awesome-icon icon="search" class="mr-3" />
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>

        <b-table
          :fields="fields"
          :items="items"
          :busy="tableBusy"
          :current-page="currentPage"
          hover
          no-border-collapse
          sort-by=""
          :sort-desc="true"
          striped
          stacked="xl"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>

          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-block d-sm-none d-xl-block" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="detalheEdital(row.item)">
                <font-awesome-icon icon="eye" />
                <span class="pl-2">Detalhes</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editarEdital(row.item)">
                <font-awesome-icon icon="pencil" />
                <span class="pl-2">Editar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="row.item.Situacao === 'Cadastrado'"
                @click="homologarEdital(row.item)"
              >
                <font-awesome-icon icon="check" />
                <span class="pl-2">Homologar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  row.item.Situacao === 'Homologado' &&
                  !row.item.FlProrrogado &&
                  row.item.FlPermiteProrrogacao
                "
                @click="openModalProrrogar(row.item)"
              >
                <font-awesome-icon icon="calendar-alt" />
                <span class="pl-2">Prorrogar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  row.item.Situacao !== 'Em Cadastramento' &&
                  row.item.Situacao !== 'Cadastrado'
                "
                @click="alertaDesfazer(row.item)"
              >
                <font-awesome-icon icon="undo" />
                <span class="pl-2"
                  >Desfazer
                  {{
                    row.item.FlProrrogado
                      ? "Prorrogação"
                      : trataNomeSituacao(row.item.Situacao)
                  }}</span
                >
              </b-dropdown-item>
              <b-dropdown-item
                v-if="row.item.Situacao === 'Homologado'"
                @click="openModalCancelar(row.item)"
              >
                <font-awesome-icon icon="ban" />
                <span class="pl-2">Cancelar</span>
              </b-dropdown-item>
              <b-dropdown-item @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <span class="pl-2">Apagar</span>
              </b-dropdown-item>
            </b-dropdown>

            <div
              class="actions-icons lgvert d-none d-sm-flex d-xl-none justify-content-around align-items-center"
            >
              <b-link class="text-dark" @click="detalheEdital(row.item)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarEdital(row.item)">
                <font-awesome-icon icon="pencil" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link
                v-if="row.item.Situacao === 'Cadastrado'"
                @click="homologarEdital(row.item)"
                class="text-dark"
              >
                <font-awesome-icon icon="check" />
                <div style="font-size: 12px">Homologar</div>
              </b-link>
              <b-link
                v-if="
                  row.item.Situacao === 'Homologado' &&
                  !row.item.FlProrrogado &&
                  row.item.FlPermiteProrrogacao
                "
                @click="openModalProrrogar(row.item)"
                class="text-dark"
              >
                <font-awesome-icon icon="calendar-alt" />
                <div style="font-size: 12px">Prorrogar</div>
              </b-link>
              <b-link
                v-if="
                  row.item.Situacao !== 'Em Cadastramento' &&
                  row.item.Situacao !== 'Cadastrado'
                "
                @click="alertaDesfazer(row.item)"
                class="text-dark"
              >
                <font-awesome-icon icon="undo" />
                <div style="font-size: 12px">
                  Desfazer
                  {{
                    row.item.FlProrrogado
                      ? "Prorrogação"
                      : trataNomeSituacao(row.item.Situacao)
                  }}
                </div>
              </b-link>
              <b-link
                v-if="row.item.Situacao === 'Homologado'"
                @click="openModalCancelar(row.item)"
                class="text-dark"
              >
                <font-awesome-icon icon="ban" />
                <div style="font-size: 12px">Cancelar</div>
              </b-link>
              <b-link class="text-dark" @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <div style="font-size: 12px">Apagar</div>
              </b-link>
            </div>
          </template>
        </b-table>

        <table-pagination
          v-if="totalRows"
          :total-rows="totalRows"
          :per-page="pageSize"
          @pageChange="pageChange"
        />
      </b-card-body>
    </b-card>

    <ModalHomologar
      v-if="modalAbertoHomologar"
      :title="title"
      :edital="edital"
      @close="closeModalHomologar"
      @reload="filtrarConcursos"
    />
    <ModalCancelar
      v-if="modalAbertoCancelar"
      :title="title"
      :edital="edital"
      @close="closeModalCancelar"
      @reload="filtrarConcursos"
    />
    <ModalProrrogar
      v-if="modalAbertoProrrogar"
      :title="title"
      :edital="edital"
      @close="closeModalProrrogar"
      @reload="filtrarConcursos"
    />
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { ValidationObserver } from "vee-validate";
import { BotaoSagres } from "@/types/botao-sagres";
import { SelectValue } from "@/types/select-value";
import { Banca } from "@/types/atos-pessoal/concursos/banca";
import { Component, Ref, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import {
  fieldsEditais,
  fieldsEditaisSead,
} from "@/types/atos-pessoal/concursos/fields-editais";
import { FiltrosEditais } from "@/types/atos-pessoal/concursos/filtros-editais";
import { EditalResumido } from "@/types/atos-pessoal/concursos/edital-resumido";
import ModalCancelar from "@/components/atos-pessoal/concursos/ModalCancelar.vue";
import ModalHomologar from "@/components/atos-pessoal/concursos/ModalHomologar.vue";
import ModalProrrogar from "@/components/atos-pessoal/concursos/ModalProrrogar.vue";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

const CompProps = Vue.extend({
  name: "FiltrarConcursos",
  components: {
    HeaderSagres,
    TablePagination,
    CardFiltrosBusca,
    ModalCancelar,
    ModalHomologar,
    ModalProrrogar,
    DefaultFormValidationProvider,
  },
});

@Component
export default class FiltrarConcursos extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  pageSize = 10;
  totalRows = 0;
  currentPage = 1;
  tableBusy = false;

  listaBancasSelect: SelectValue[] = [];
  listaTiposSelect: SelectValue[] = [
    { value: null, text: "Selecionar tipo" },
    { value: 1, text: "Concurso" },
    { value: 2, text: "Processo Seletivo Público" },
    { value: 3, text: "Processo Seletivo Simplificado" },
  ];
  listaSituacaoSelect: SelectValue[] = [
    { value: null, text: "Selecionar situação" },
    { value: 1, text: "Em Cadastramento" },
    { value: 2, text: "Homologado" },
    { value: 3, text: "Cancelado" },
    { value: 4, text: "Cadastrado" },
  ];

  items: EditalResumido[] = [];
  fields: TableField[] = fieldsEditais;
  filtros: FiltrosEditais = new FiltrosEditais();
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "plus",
      texto: "Cadastrar Novo",
      url: "/atos-pessoal/concursos/criar-concurso",
    },
  ];

  title = "";
  edital: any = {};
  modalAbertoCancelar = false;
  modalAbertoHomologar = false;
  modalAbertoProrrogar = false;

  listaResponsavelSelect: SelectValue[] = [];
  ehSEAD = false;

  async mounted(): Promise<void> {
    await this.loadUgs();
    await this.filtrarConcursos();
    this.insituicoesSelect();
    this.fields = this.ehSEAD ? fieldsEditaisSead : fieldsEditais;
  }

  async loadUgs() {
    try {
      const response = await concursoService.getAllUgs();
      this.listaResponsavelSelect = response.map((ug: any) => ({
        text: ug.NmNome,
        value: ug.CodUgSagres,
      }));
      this.ehSEAD = true;
    } catch (e: unknown) {
      console.error("Erro ao carregar UGs", e);
      this.ehSEAD = false;
    }
  }

  async insituicoesSelect() {
    try {
      this.tableBusy = true;
      const response = await concursoService.getBancas();
      if (response === null || response === undefined)
        return this.$toast.error("Erro ao obter a lista de Bancas");
      this.listaBancasSelect = [
        { value: "", text: "Selecionar banca" },
        ...response.map((b: Banca) => ({
          value: b.IdBanca,
          text: b.NomeBanca,
        })),
      ];
      this.filtros.Banca = String(this.listaBancasSelect[0].value);
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      this.tableBusy = false;
    }
  }

  async pageChange(value: number): Promise<void> {
    this.currentPage = value;
    await this.filtrarConcursos();
  }

  async filtrarConcursos() {
    try {
      this.tableBusy = true;
      const response = await concursoService.getConcursos(
        this.currentPage,
        this.filtros
      );
      if (response === null || response === undefined)
        return this.$toast.error("Erro ao obter a lista de Editais");
      this.items = response.editais.map((e: EditalResumido) => ({
        ...e,
        DtPublicacao: this.formatData(e.DtPublicacao),
        DtInicioInscricao: this.formatData(e.DtInicioInscricao),
        DtFimInscricao: this.formatData(e.DtFimInscricao),
      }));
      this.currentPage = response.page;
      this.totalRows = response.totalRows;
    } catch (error: any) {
      this.tratarError(error);
      this.items = [];
      this.totalRows = 0;
    } finally {
      this.tableBusy = false;
    }
  }

  limparFiltro(): void {
    this.filtros.limpar();
  }
  homologarEdital(edital: EditalResumido): void {
    this.$router.push(
      `/atos-pessoal/concursos/editar-edital/${edital.IdEdital}/3`
    );
  }

  detalheEdital(edital: EditalResumido): void {
    this.$router.push(
      `/atos-pessoal/concursos/detalhes-edital/${edital.IdEdital}`
    );
  }

  editarEdital(edital: EditalResumido): void {
    this.$router.push(
      `/atos-pessoal/concursos/editar-edital/${edital.IdEdital}/0`
    );
  }

  alertaRemove(edital: EditalResumido): void {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja remover o edital Nº ${edital.NrEdital} / Ano ${edital.AnoEdital} ?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          okVariant: "secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Apagar edital",
        }
      )
      .then((value) => {
        if (value && edital.IdEdital) this.removerEdital(edital.IdEdital);
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção edital`,
          err
        );
      });
  }

  async removerEdital(IdEdital: number) {
    try {
      this.tableBusy = true;
      const response = await concursoService.removerEdital(IdEdital);
      if (response && response.status < 200 && response.status >= 300)
        return this.$toast.error("Erro ao remover edital");
      this.$toast.success("Edital removido com sucesso");
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      await this.filtrarConcursos();
      this.tableBusy = false;
    }
  }

  trataNomeSituacao(situacao: string): string {
    switch (situacao) {
      case "Homologado":
        return "Homologação";
      case "Cancelado":
        return "Cancelamento";
      case "Prorrogação":
        return "Prorrogação";
      default:
        return "";
    }
  }

  alertaDesfazer(edital: EditalResumido): void {
    this.$bvModal
      .msgBoxConfirm(
        edital.FlProrrogado
          ? `Deseja desfazer a PRORROGAÇÃO do edital Nº ${edital.NrEdital} / Ano ${edital.AnoEdital} ?`
          : `Deseja desfazer ${this.trataNomeSituacao(
              edital.Situacao
            ).toUpperCase()} do edital Nº ${edital.NrEdital} / Ano ${
              edital.AnoEdital
            } ?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          okVariant: "secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: edital.FlProrrogado
            ? "Desfazer PRORROGAÇÃO"
            : `Desfazer ${this.trataNomeSituacao(
                edital.Situacao
              ).toUpperCase()}`,
        }
      )
      .then((value) => {
        if (value && edital.IdEdital)
          this.desfazerSituacao(
            edital.IdEdital,
            edital.Situacao,
            edital.FlProrrogado
          );
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta para desfazer situação`,
          err
        );
      });
  }

  async desfazerSituacao(
    idEdital: number,
    situacao: string,
    prorrogado: boolean
  ): Promise<void> {
    try {
      this.tableBusy = true;
      const response = await concursoService.desfazerSituacao(
        idEdital,
        situacao,
        prorrogado
      );
      if (response) this.$toast.success("Situação desfeita com sucesso!");
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      this.tableBusy = false;
      await this.filtrarConcursos();
    }
  }

  openModalHomologar(edital: EditalResumido): void {
    try {
      this.tableBusy = true;
      this.edital = edital;
      this.title = `Homologar Edital Nº ${this.edital.NrEdital} / Ano ${this.edital.AnoEdital}`;
      this.modalAbertoHomologar = true;
    } catch (error) {
      console.error(error);
    } finally {
      this.tableBusy = false;
    }
  }
  openModalCancelar(edital: EditalResumido): void {
    try {
      this.tableBusy = true;
      this.edital = edital;
      this.title = `Cancelar Edital Nº ${this.edital.NrEdital} / Ano ${this.edital.AnoEdital}`;
      this.modalAbertoCancelar = true;
    } catch (error) {
      console.error(error);
    } finally {
      this.tableBusy = false;
    }
  }
  openModalProrrogar(edital: EditalResumido): void {
    try {
      this.tableBusy = true;
      this.edital = edital;
      this.title = `Prorrogar Edital Nº ${this.edital.NrEdital} / Ano ${this.edital.AnoEdital}`;
      this.modalAbertoProrrogar = true;
    } catch (error) {
      console.error(error);
    } finally {
      this.tableBusy = false;
    }
  }

  closeModalHomologar(): void {
    this.modalAbertoHomologar = false;
  }
  closeModalCancelar(): void {
    this.modalAbertoCancelar = false;
  }
  closeModalProrrogar(): void {
    this.modalAbertoProrrogar = false;
  }
}
</script>
